function clipboardImageItems(items) {
  const files = [];
  if (!items || typeof items.length !== 'number') return files;
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (!item || item.kind === 'string') continue;
    const type = String(item.type || '');
    if (type && !type.startsWith('image/')) continue;
    const file = typeof item.getAsFile === 'function' ? item.getAsFile() : null;
    if (file) files.push(file);
  }
  return files;
}

function clipboardImageName(file) {
  const raw = String((file && file.name) || '').trim();
  if (!raw || raw.toLowerCase() === 'image.png') return 'screenshot.png';
  return raw;
}

function fileFromClipboardBytes(file, bytes) {
  const buffer = bytes instanceof ArrayBuffer ? bytes : null;
  if (!buffer || buffer.byteLength === 0) return null;
  const type = String((file && file.type) || '');
  return new File([buffer], clipboardImageName(file), {
    type: type.startsWith('image/') ? type : 'image/png',
    lastModified: Date.now(),
  });
}

function readBlobBytes(blob) {
  if (blob && typeof blob.arrayBuffer === 'function') return blob.arrayBuffer();
  return Promise.reject(new Error('unreadable clipboard image'));
}

function readClipboardImage(file, readBytes = readBlobBytes) {
  if (!file) return Promise.resolve(null);
  return Promise.resolve()
    .then(() => readBytes(file))
    .then((bytes) => fileFromClipboardBytes(file, bytes))
    .catch(() => null);
}

module.exports = {
  clipboardImageItems,
  fileFromClipboardBytes,
  readClipboardImage,
};
